import { RouteObject } from "react-router";

import { convertRouteModule } from "../../../lib/routing";

export const reportsRoutes: Array<RouteObject> = [
  { index: true, lazy: async () => convertRouteModule(await import("./reports")) },
  {
    path: ":reportId",
    lazy: async () => convertRouteModule(await import("./report-download")),
  },
];
